module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eZKk1"))).then(() => parcelRequire('f4eak'));